module.exports = __webpack_public_path__ + "assets/sounds/bubble.mp3";